import { combineReducers } from 'redux';
import {
  IMAGE_UPDATED,
  IMAGE_DELETED,
  CATCH_IMAGE_UPDATED,
  CATCH_IMAGE_DELETED,
} from 'news/actions/images';
import { INITIAL_DATA_LOAD_SUCCESS } from 'news/actions';

const strategies = (state = {}, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return {
        image: action.strategy,
        catchImage: action.catchStrategy,
      };
    default:
      return state;
  }
};

const resources = (state = {}, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return {
        image: action.image,
        catchImage: action.catchImage,
      };
    case IMAGE_UPDATED:
      return {
        ...state,
        image: action.image,
      };
    case CATCH_IMAGE_UPDATED:
      return {
        ...state,
        catchImage: action.image,
      };
    case IMAGE_DELETED:
      return {
        ...state,
        image: undefined,
      };
    case CATCH_IMAGE_DELETED:
      return {
        ...state,
        catchImage: undefined,
      };
    default:
      return state;
  }
};

export default combineReducers({
  strategies,
  resources,
});

export const getImageStrategy = state => state.images.strategies.image;
export const getImage = state => state.images.resources.image;
export const getCatchImageStrategy = state =>
  state.images.strategies.catchImage;
export const getCatchImage = state => state.images.resources.catchImage;



// WEBPACK FOOTER //
// ./src/modules/news/reducers/images.js